import { c as _c } from "react/compiler-runtime";
export function TeDecisionFlow() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="font-semibold mb-1">TE Decision Flow</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li><strong>No</strong> → Create new TE</li>;
    t2 = <strong>Yes</strong>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li><strong>No</strong> → Upload as Follow Up Document and attach to the TE; Add Notes to "action taken" on TE</li>;
    t4 = <strong>Yes</strong>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <em>addressed</em>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="pl-3 mt-1 mb-2 border-l-2 border-green-500/30">{t0}<ol className="list-decimal pl-5 space-y-1"><li>Is there a TE on file for the same request received?<ul className="list-disc pl-5 mt-1 space-y-1">{t1}<li>{t2} → Make sure the Orders/message match (different senders is ok)<ul className="list-disc pl-5 mt-1 space-y-1"><li>Has it been over 7 days?<ul className="list-disc pl-5 mt-1 space-y-1">{t3}<li>{t4} → Does the previous {t5} TE on file have MHS documentation?<ul className="list-disc pl-5 mt-1 space-y-1"><li><strong>Yes</strong> → Upload as Duplicate Document</li><li><strong>No</strong> → Create new TE</li></ul></li></ul></li></ul></li></ul></li></ol></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
export function GlobalAlertInstructions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pl-3 mt-1 mb-2 border-l-2 border-green-500/30"><p className="font-semibold mb-1">Global Alert Instructions</p><p>Navigate to Billing Alerts on the patient chart → click the settings button (top-right corner) → select the reason for the alert.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}